import { render, staticRenderFns } from "./recommendList.vue?vue&type=template&id=e15094f4&scoped=true&"
import script from "./recommendList.vue?vue&type=script&lang=js&"
export * from "./recommendList.vue?vue&type=script&lang=js&"
import style0 from "./recommendList.vue?vue&type=style&index=0&id=e15094f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15094f4",
  null
  
)

export default component.exports